import { useCustomerTypes } from '@diamond/sol-admin/features/shipto';
import { useQueryClient } from '@tanstack/react-query';

export const useCustomerTypesData = () => {
  const queryClient = useQueryClient();

  const customerTypesQuery = useCustomerTypes();

  // Enhanced refetch with cache invalidation
  const enhancedRefetch = async () => {
    await queryClient.invalidateQueries({ queryKey: ['Customer Types'] });
    return customerTypesQuery.refetch();
  };

  // Get customer type label by value
  const getCustomerTypeLabel = (value: string): string => {
    return customerTypesQuery.maps[value] || '-';
  };

  // Check if customer type exists
  const hasCustomerType = (value: string): boolean => {
    return value in customerTypesQuery.maps;
  };

  // Get all customer type values
  const getCustomerTypeValues = (): string[] => {
    return customerTypesQuery.options.map((option) => option.value);
  };

  // Get customer type options for specific values
  const getCustomerTypeOptionsForValues = (values: string[]) => {
    return customerTypesQuery.options.filter((option) =>
      values.includes(option.value)
    );
  };

  return {
    // Original query data
    ...customerTypesQuery,

    // Enhanced actions
    refetch: enhancedRefetch,

    // Utility functions
    getCustomerTypeLabel,
    hasCustomerType,
    getCustomerTypeValues,
    getCustomerTypeOptionsForValues,

    // Computed values
    isLoaded: customerTypesQuery.isSuccess,
    hasData: customerTypesQuery.options.length > 0,
    isEmpty:
      customerTypesQuery.isSuccess && customerTypesQuery.options.length === 0,
  };
};
